import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Documento } from 'src/app/model/documenti/Documento';
import { Router } from '@angular/router';
import { AppConstants } from 'src/environments/constants';
import { TranslateService } from '@ngx-translate/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-documents-card',
  templateUrl: './documents-card.component.html',
  styleUrls: ['./documents-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentsCardComponent implements OnInit, OnDestroy {
  @Input() documento!: Documento;
  @Input() disabled = false;

  tagLabel = '';
  avatarLabel = '';
  orderLabel = '';
  positionLabel = '';

  private readonly subs = new Subscription();

  constructor(
    private readonly router: Router,
    private readonly translate: TranslateService,
    private readonly breakpointObserver: BreakpointObserver
  ) {}

  ngOnInit(): void {
    this.buildAll();

    // Aggiorna on language change
    this.subs.add(this.translate.onLangChange.subscribe(() => this.buildAll()));

    // Breakpoints: utile se vorrai adattare layout per mobile/tablet (non strettamente necessario qui)
    this.subs.add(this.breakpointObserver.observe([Breakpoints.Handset, Breakpoints.Tablet, Breakpoints.Web])
      .subscribe(() => {
        // ricostruisci eventuali label che dipendono da layout
        this.buildAll();
      }));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private buildAll(): void {
    this.buildTagLabel();
    this.buildAvatarLabel();
    this.orderLabel = this.translate.instant('ordini.order') || 'Ordine';
    this.positionLabel = this.translate.instant('ordini.position') || 'Posizione';
  }

  private buildTagLabel(): void {
    if (!this.documento?.tipologiaDocumento) {
      this.tagLabel = '';
      return;
    }
    const key = `documenti.tipo.${this.documento.tipologiaDocumento}`;
    const t = this.translate.instant(key);
    this.tagLabel = t === key ? this.documento.tipologiaDocumento : t;
  }

  private buildAvatarLabel(): void {
    const ruolo = this.documento?.ruolo;
    if (!ruolo) { this.avatarLabel = ''; return; }

    const tipoKey = `utente.${ruolo.tipologiaUtente}`;
    const tipoTranslated = this.translate.instant(tipoKey);
    const tipo = tipoTranslated === tipoKey ? (ruolo.tipologiaUtente) : tipoTranslated;

    const nome = ruolo.nome ?? '';
    const cognome = ruolo.cognome ?? '';

    this.avatarLabel = `${tipo}: ${nome} ${cognome}`.trim();
  }

  goToPreview(): void {
    if (!this.documento) return;
    this.router.navigate([AppConstants.PREVIEW_DOCUMENTO_ROUTE, this.documento.id], { state: { documento: this.documento } });
  }
}